import { styled } from '@mui/material/styles';
import Grid from "@mui/material/Grid";
import { Box, Typography } from '@mui/material';

const GridContainer = styled(Grid)(({ theme: { palette: { secondary } }}) => `
  background-color: ${secondary.main};
  border-radius: 16px;
  padding: 10px 10px 26px 10px;
  margin: 0 !important;
  width: 100% !important;
  &&.edit {
    box-shadow: 0px 3px 6px #22222229;
    }
`);

const Label = styled(Typography)(({ theme: { palette: { primary }, breakpoints }}) => `
  color: ${primary.main};
  margin-top: 5px;
  margin-Bottom: 5px;
  text-transform: uppercase;
  ${[breakpoints.down('sm')]} {
    line-height: 16.5px;
  }
`);

const Value = styled(Typography)(({ theme: { breakpoints } }) => `
  user-select: text;
  ${[breakpoints.down('sm')]} {
    line-height: 24px;
  }
`);

const CustomGrid = styled(Grid)`
    &.removePadding {
        padding-top: 0 !important;
    }
`;

const LABELS = {
    contactInfoSectionLabel: 'Contact Information',
    contactNameLabel: 'Name',
    contactInfoEmailLabel: 'Email',
    contactRoleLabel: 'Role',
    notFound: '-'
}

export const ContactInfo = ({ pageType, contactName, contactEmail, contactRole }) => {
    return(
        <Box margin='30px auto 0 auto' width='80%' id="ContactInformation">
            <Typography variant={'h3'} fontFamily={'Aeonik Light'} color='primary.main' textAlign='left' mb='25px' mt='30px'>{LABELS.contactInfoSectionLabel}</Typography>
            <GridContainer container className={pageType} spacing={2}>
                <Grid item xs={12} md={6}>
                    <Label variant={'h6'} id="contactNameLabel">{LABELS.contactNameLabel}</Label>
                    {contactName && <Value variant={'p1'} id="contactNameValue">{contactName}</Value>}
                </Grid>
                <Grid item xs={12} md={6}>
                    <Label variant={'h6'} id="contactInfoEmailLabel">{LABELS.contactInfoEmailLabel}</Label>
                    {contactEmail && <Value variant={'p1'} id="contactEmail">{contactEmail}</Value>}
                </Grid>
                <CustomGrid item xs={12} md={6}>
                    <Label variant={'h6'} id="contactRoleLabel">{LABELS.contactRoleLabel}</Label>
                    <Value variant={'p1'} id="contactRole">{contactRole ? contactRole : LABELS.notFound}</Value>
                </CustomGrid>
            </GridContainer>
        </Box>
    )
}
